<template>
  <div>
    <div class="app-toolbar1"><el-button type="primary" size="small" @click="toAdd">添加</el-button></div>
    <el-table :data="uis" :stripe="true" v-loading="loading">
      <el-table-column prop="uiId" label="ID" width="40"></el-table-column>
      <el-table-column prop="title" label="前端系统标题" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank" style="color:#409EFF">{{scope.row.title}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="UI类型" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'ELEMENT_UI'">Element UI</span>
          <span v-if="scope.row.type === 'VUX'">VUX</span>
          <span v-if="scope.row.type === 'FLUTTER'">Flutter</span>
        </template>
      </el-table-column>
      <el-table-column prop="homePageId" label="首页" width="60"></el-table-column>
      <el-table-column prop="needLogin" label="是否需要登录" width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.needLogin === 'YES'">是</span>
          <span v-if="scope.row.needLogin === 'NO'">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="systemName" label="所属后端系统" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间" width="153"></el-table-column>
      <el-table-column fixed="right" label="操作" width="440">
        <template slot-scope="scope">
          <el-button @click="toUpdate(scope.row)" type="primary" size="mini">修改</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="mini">删除</el-button>
          <el-button @click="toManagePage(scope.row)" type="primary" size="mini">页面管理</el-button>
          <el-button @click="toManageForm(scope.row)" type="primary" size="mini">表单管理</el-button>
          <el-button @click="toManageComponent(scope.row, c.group)" type="primary" size="mini" v-for="(c, i) in endpointGroupMap[scope.row.type]" :key="i">{{ c.text }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="formTitle" :visible.sync="showForm" @close="resetForm">
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-width="120px">
        <el-form-item label="所属后端系统" prop="systemId">
          <el-select v-model="form.systemId" placeholder="所属后端系统" style="width:100%;">
            <el-option v-for="system in systems" :key="system.systemId" :label="system.name" :value="system.systemId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="UI类型" prop="type" width="120">
          <el-radio-group v-model="form.type" size="mini">
            <el-radio-button label="ELEMENT_UI">Element UI</el-radio-button>
            <el-radio-button label="VUX">VUX</el-radio-button>
            <el-radio-button label="FLUTTER">Flutter</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="前端系统标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入前端系统标题" :maxlength="60"></el-input>
        </el-form-item>
        <el-form-item label="前端系统描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请输入前端系统描述" :maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="访问或下载地址" prop="url">
          <el-input v-model="form.url" placeholder="请输入访问或下载地址" :maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="首页ID" prop="homePageId">
          <el-input v-model="form.homePageId" type="number" placeholder="请输入首页ID"></el-input>
        </el-form-item>
        <el-form-item label="是否需要登录" prop="needLogin">
          <el-radio-group v-model="form.needLogin" size="mini">
            <el-radio-button label="YES">是</el-radio-button>
            <el-radio-button label="NO">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="前端系统配置" prop="config">
          <el-input v-model="form.config" type="textarea" rows="6" placeholder="请输入前端系统配置"></el-input>
        </el-form-item>
        <el-form-item label="前端系统图标" prop="favicon">
          <el-upload :action="fileServer" :data="fileData" :multiple="false" :file-list="fileList" show-file-list list-type="picture" :on-remove="onFileRemove" :on-success="onUploadSuccess">
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="页面管理" :visible.sync="showPageManage" width="96%">
      <page-manage :endpoint="endpointOfPageManage" :uiId="uiIdOfPageManage"></page-manage>
    </el-dialog>

    <el-dialog title="表单管理" :visible.sync="showFormManage" width="96%">
      <form-manage :endpoint="endpointOfFormManage" :uiId="uiIdOfFormManage"></form-manage>
    </el-dialog>

    <el-dialog title="组件管理" :visible.sync="showComponentManage" width="96%">
      <component-manage :endpoint="endpointOfComponentManage" :uiId="uiIdOfComponentManage" :group="groupOfComponentManage"></component-manage>
    </el-dialog>
  </div>
</template>

<script>
import { fls } from '@/config'
import { getEndpointPath, endpointGroupMap } from '../page/util'
import PageManage from '../page/PageManage'
import FormManage from '../page/FormManage'
import ComponentManage from '../page/ComponentManage'

export default {
  name: 'cg-ui-manage',
  components: {
    FormManage,
    PageManage,
    ComponentManage
  },
  data () {
    return {
      loading: false,
      uis: [],
      showForm: false,
      formTitle: '添加前端系统',
      form: {
        systemId: null,
        uiId: null,
        type: null,
        title: null,
        url: null,
        desc: null,
        homePageId: null,
        needLogin: 'YES',
        favicon: null,
        config: null
      },
      formRule: {
        systemId: [{ required: true, message: '请选择所属后端系统', trigger: 'blur' }],
        type: [{ required: true, message: '请选择UI类型', trigger: 'blur' }],
        title: [{ required: true, message: '请输入前端系统标题', trigger: 'blur' }]
      },

      fileServer: `${fls}/files`,
      filePrefix: `${fls}/static-file`,
      fileData: { path: 'sf' },
      fileList: [],
      systems: [],
      endpointOfPageManage: null,
      uiIdOfPageManage: null,
      showPageManage: false,
      endpointOfFormManage: null,
      uiIdOfFormManage: null,
      showFormManage: false,
      endpointOfComponentManage: null,
      uiIdOfComponentManage: null,
      groupOfComponentManage: null,
      showComponentManage: false,
      endpointGroupMap: []
    }
  },
  created () {
    this.load()
    this.endpointGroupMap = endpointGroupMap
  },
  methods: {
    load () {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: '/api/cgUis'
      }).then((res) => {
        this.uis = res.data.data
        this.loading = false
      })
    },
    loadSystem () {
      if (this.systems && this.systems.length > 0) {
        return
      }
      this.$http.request({
        method: 'get',
        url: '/api/cgSystems'
      }).then((res) => {
        this.systems = res.data.data
      })
    },
    toAdd () {
      this.form = { systemId: null, uiId: null, type: null, title: null, url: null, desc: null, homePageId: null, needLogin: 'YES', favicon: null, config: null }
      this.fileList = []
      this.formTitle = '添加前端系统'
      this.showForm = true
      this.loadSystem()
    },
    toUpdate (row) {
      this.formTitle = '修改前端系统'
      this.form = { systemId: row.systemId, uiId: row.uiId, type: row.type, title: row.title, url: row.url, desc: row.desc, homePageId: row.homePageId, needLogin: row.needLogin, favicon: row.favicon, config: row.config }
      this.fileList = row.favicon ? [{name: '前端系统图标', url: this.filePrefix + row.favicon}] : []
      this.showForm = true
      this.loadSystem()
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该前端系统吗?', data: row, scope: this, callback: this.doDelete })
    },
    doSave () {
      this.$refs.form.validate((success) => {
        if (success) {
          let uiId = this.form.uiId
          this.$http.request({
            method: !uiId ? 'post' : 'put',
            url: !uiId ? '/api/cgUis' : `/api/cgUis/${uiId}`,
            data: JSON.stringify(this.form)
          }).then(() => {
            this.showForm = false
            this.load()
          })
        } else {
          return false
        }
      })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgUis/${data.uiId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load()
        })
      }
    },
    onFileRemove () {
      this.form.favicon = null
      this.fileList = []
    },
    onUploadSuccess (res) {
      this.form.favicon = res.data
      this.fileList = [{name: '前端系统图标', url: this.filePrefix + res.data}]
    },
    resetForm () {
      this.$refs.form.resetFields()
    },
    toManagePage (row) {
      this.uiIdOfPageManage = row.uiId
      this.endpointOfPageManage = getEndpointPath(row.type)
      this.showPageManage = true
    },
    toManageForm (row) {
      this.uiIdOfFormManage = row.uiId
      this.endpointOfFormManage = getEndpointPath(row.type)
      this.showFormManage = true
    },
    toManageComponent (row, group) {
      this.uiIdOfComponentManage = row.uiId
      this.groupOfComponentManage = group
      this.endpointOfComponentManage = getEndpointPath(row.type)
      this.showComponentManage = true
    }
  }
}
</script>
